import { AccordionContent } from 'semantic-ui-react';
import styled from 'styled-components';
import { getScrollBarStyles } from '../../../config/styles';
import { InputField } from '../../Form';
import { theme } from '../../../styles/theme';
import { floatingComponentStyles } from '../../../styles/shareableStyles';

export const Wrapper = styled.div`
  width: 240px;
  padding: 12px;
  ${floatingComponentStyles};
  color: ${theme.colors.secondary800};

  .ui.accordion .title {
    font: inherit;
    font-weight: 500;
  }
  .ui.accordion .title:not(.ui) {
    color: inherit;
    &:hover {
      color: ${theme.colors.mainBlue};
    }
  }
`;

export const StyledAccordionContent = styled(AccordionContent)`
  margin-left: 32px;
`;

export const AccordionItem = styled.div<{ $isActive: boolean }>`
  color: ${({ $isActive }) => ($isActive ? theme.colors.mainBlue : 'inherit')};
  &:hover {
    color: ${theme.colors.mainBlue};
    cursor: pointer;
  }
`;

export const AccordionRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
  margin: 4px 0;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 12px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
`;

export const ActionItem = styled.div`
  font-size: 12px;
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

export const StyledInputField = styled(InputField)`
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 112px;
  overflow-y: auto;
  ${getScrollBarStyles(2)};
`;

export const ListItem = styled(ActionsContainer)<{ $isActive: boolean }>`
  cursor: pointer;
  height: 28px;
  padding: 0 8px;
  &:hover {
    color: ${theme.colors.mainBlue};
  }

  ${({ $isActive }) =>
    $isActive &&
    `
    color: ${theme.colors.mainBlue};
    font-weight: 600;
  `};
`;

export const ListValue = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 176px;
  white-space: nowrap;
`;

export const Space = styled.div`
  width: 12px;
`;
